import { Col, Row } from 'antd';
import React from 'react';

const IntroText = ({ isTabletOrMobile }) => {
    return (
        <Row className='intro'>
                <p className='intro-text'>At Cenvance we are dedicated to revolutionizing the field of laboratory equipment,
                    medical devices, and lab consumables. With a strong foundation in scientific innovation and precision
                    engineering, we provide high-quality solutions that empower research laboratories, hospitals, and
                    diagnostic centers worldwide. Our expertise spans a wide range of advanced laboratory instruments and medical technologies,
                    ensuring that scientists, healthcare professionals, and researchers have access to tools that drive
                    discovery and improve patient care. Whether it's microscopes, centrifuges, spectrophotometers, or
                    diagnostic analyzers, we deliver cutting-edge solutions that meet the highest industry standards.</p>
        </Row>
    );
}

export default IntroText;